module.exports = __webpack_public_path__ + "img/ordenes.a396d896.svg";